import { useToggle } from "utils/Hooks"
import { FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { LeftArrow } from "components/views/fle/Molecules"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"
import { Body, BodySmall } from "../../atoms/Bodies"
import { Checkbox } from "../../atoms/Checkbox"
import { IlloPaperAirplane } from "../../atoms/Illustrations"
import { TextLink } from "../../atoms/links/TextLink"
import FLEInformationModal from "../../modal/FLEInformationModal"
import L10n from "lib/carrot-l10n"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const EmailOptIn = ({ emailOptIn, setEmailOptIn, onBack, onComplete, benefitConfiguration }) => {
  const [showPrivacyPolicyModal, togglePrivacyPolicyModal] = useToggle(false)

  return (
    <FleLayout>
      <TopSection progressStep={1} leftOrBackArrow={<LeftArrow onClick={onBack} />} />
      <FlexRowCenter>
        <IlloPaperAirplane />
      </FlexRowCenter>
      <Spacer height={1.5} />
      <H1 variant="dark">Subscribe to updates</H1>
      <Spacer height={0.5} />
      <Body color="black-80">
        {l`Get the most out of your Carrot benefit. From time to time, we'll share articles, interviews, and tips. Meet our
        experts, find out about new promotions, and explore new features.`}
      </Body>
      <Spacer height={2} />
      <label>
        <div className="flex flex-row">
          <Checkbox checked={emailOptIn} onChange={(e) => setEmailOptIn(e.target.checked)} />
          <div className="ml2">
            <Body>Yes, subscribe me to updates so I can get the most out of my benefit.</Body>
            <Spacer height={1} />
            <BodySmall>
              We will protect your data in accordance with our&nbsp;
              <TextLink underlineColor="black-80" onClick={togglePrivacyPolicyModal}>
                {l`fle2.privacyPolicy`}
              </TextLink>
              , and you can unsubscribe at any time in your account settings.
            </BodySmall>
          </div>
        </div>
      </label>
      <Spacer height={3} />
      <FleLinkWrapper spacerHeight={1.5}>
        <ArrowLink onClick={onComplete}>Continue</ArrowLink>
      </FleLinkWrapper>
      {showPrivacyPolicyModal ? (
        <FLEInformationModal
          onClose={togglePrivacyPolicyModal}
          header={l`fle2.privacyPolicy`}
          source={l`fle2.privacyPolicyFull`}
          benefitConfiguration={benefitConfiguration}
          showInDesktopView
          isTCPPModal
        />
      ) : null}
    </FleLayout>
  )
}
